/*
 * 获取guid方法
 */
const uuid = () => {
	var s = [];
	var hexDigits = "0123456789abcdef";
	for (var i = 0; i < 36; i++) {
		s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
	}
	s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
	s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
	s[8] = s[13] = s[18] = s[23] = "-";

	var uuid = s.join("");
	return uuid;
}
/*
 * 清除input
 */
const clearInputFile = (f) => {
	if (f.value) {
		try {
			f.value = ''; //for IE11, latest Chrome/Firefox/Opera...
		} catch (err) { }
		if (f.value) { //for IE5 ~ IE10
			var form = document.createElement('form'),
				ref = f.nextSibling;
			form.appendChild(f);
			form.reset();
			ref.parentNode.insertBefore(f, ref);
		}
	}
}
//blob转base64
const blobToBase64 = (blob, callback) => {
	var a = new FileReader();
	a.onload = function (e) {
		callback(e.target.result);
	}
	a.readAsDataURL(blob);
}
const download = (that, src, data) => {
	that.$axios.get(src, {
		params: data
	}).then(res => {
		if (res.success) {
			let a = document.createElement("a");
			a.href = res.data;
			a.click();
		}
	})
}
//获取链接地址的参数
const getQueryString = (name) => {
	var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
	var r = window.location.search.substr(1).match(reg);
	if (r != null) return decodeURIComponent(r[2]);
	return null;
}
/*
 * 比较两个时间的大小
 * sDate1和sDate2是2006-12-18格式
 */
const dateDiff = (sDate1, sDate2) => {
	var oDate1, oDate2;
	if (sDate1 && sDate1.indexOf("-") > 0) {
		sDate1.replace(/-/g, "/");
		oDate1 = new Date(sDate1) //转换为12-18-2006格式
	}
	if (sDate2 && sDate2.indexOf("-") > 0) {
		sDate2.replace(/-/g, "/");
		oDate2 = new Date(sDate2);
	}
	if (!sDate2) {
		oDate2 = new Date();
	}
	if (oDate1.getTime() > oDate2.getTime()) {
		return true;
	} else {
		return false;
	}
}
// 手机号正则校验
const checkPhoneNumber = (phoneNumber) => {
	var reg = /^0?1[3|4|5|7|8|9][0-9]\d{8}$/;
	return reg.test(phoneNumber);
}

//邮箱正则判断
const checkEmail = (email) => {
	var reg =  /^[a-z]([a-z0-9]*[-_.]?[a-z0-9]+)*@([a-z0-9]*[-_.]?[a-z0-9]+)+[\.][a-z]{2,3}([\.][a-z]{2})?$/gi;
	return reg.test(email);
}
export default {
	uuid,//获取uuid
	clearInputFile,//清除本地上传文件
	blobToBase64,//blob转base64
	getQueryString,//获取链接地址中的参数，应用不到
	dateDiff,//对比两个日期的大小
	checkPhoneNumber,//验证手机号
  checkEmail,//验证邮箱
	download //下载
}



// WEBPACK FOOTER //
// ./src/utils/global.js